export const nav_carbon = "Carbon";
export const nav_builds = "Builds";
export const nav_atelier = "Atelier";
export const nav_models = "Modelle";
export const nav_process = "Prozess";
export const nav_contact = "Kontakt";
export const nav_about = "Über Uns";
export const nav_cta = "Starten Sie Ihren Build";

export const hero_tagline = "Aus Carbon Gefertigt. Ohne Kompromisse Gebaut.";
export const hero_cta_primary = "Konfigurieren Sie Ihres";
export const hero_cta_secondary = "Modelle Erkunden";
export const hero_scroll = "Scrollen zum Entdecken";
export const hero_video_toggle = "Video";
export const hero_slides_toggle = "Folien";
export const hero_mute = "Stumm";
export const hero_unmute = "Ton An";

export const manifest_title = "Das Veragua Manifest";
export const manifest_text = "Wir entwickeln jenseits von Konventionen. Jede Komponente wird geprüft, jede Oberfläche verfeinert. Carbon ist keine Materialwahl—es ist unser Fundament. Leistung ist kein Feature—es ist unsere Obsession. Wir folgen keinen Trends. Wir setzen Standards.";
export const manifest_line1 = "Das ist kein Styling.";
export const manifest_line2 = "Das ist Rekonstruktion.";
export const manifest_line3 = "3D-gescannt. Konstruiert. Handgefertigt.";

export const carbon_title = "Carbon Division";
export const carbon_subtitle = "Ingenieurskunst par Excellence";
export const carbon_desc = "Unsere Carbon Division repräsentiert den Gipfel der Leichtbau-Ingenieurskunst. Jede Komponente wird sorgfältig aus luft- und raumfahrttauglichem Carbon gefertigt, wodurch das Gewicht reduziert und gleichzeitig strukturelle Integrität und Leistung maximiert werden.";
export const carbon_cta = "Carbon-Technologie Erkunden";
export const carbon_division_label = "ABTEILUNG 01";
export const carbon_division_title1 = "CARBON";
export const carbon_division_title2 = "DIVISION";
export const carbon_division_desc = "Jede Komponente wird von rohem Verbundwerkstoff bis zum fertigen Teil im eigenen Haus entwickelt. Kein Outsourcing. Kein Kompromiss.";
export const carbon_custom_config = "Individuelle Konfigurationen für alle Plattformen verfügbar.";
export const carbon_request_build = "INDIVIDUELLEN BUILD ANFRAGEN";
export const carbon_view_details = "DETAILS ANSEHEN";
export const carbon_materials_label = "MATERIALIEN";
export const carbon_process_label = "PROZESS";

export const builds_title = "Signature Builds";
export const builds_subtitle = "Meisterwerke in Bewegung";
export const builds_view = "Build Ansehen";
export const builds_limited_series = "Limitierte Serie";
export const builds_each_build = "Jeder Build ist ein einzigartiges Statement. Zur Perfektion entwickelt. Auf zehn limitiert.";
export const builds_view_project = "PROJEKT ANSEHEN";

export const engineering_title = "Ingenieursdetails";
export const engineering_subtitle = "Präzision in Jeder Komponente";
export const engineering_tab_chassis = "Chassis";
export const engineering_tab_aero = "Aerodynamik";
export const engineering_tab_power = "Antrieb";
export const engineering_chassis_title = "Carbon-Monocoque-Chassis";
export const engineering_chassis_desc = "Unser proprietäres Carbon-Monocoque-Chassis bietet außergewöhnliche Steifigkeit bei minimalem Gewicht. Jede Schicht ist präzise für ein optimales Festigkeits-Gewichts-Verhältnis konstruiert.";
export const engineering_aero_title = "Aktive Aerodynamik";
export const engineering_aero_desc = "Intelligente aerodynamische Systeme passen sich in Echtzeit an und optimieren Abtrieb und Luftwiderstand für jede Fahrsituation. Im Windkanal getestet, auf der Rennstrecke bewährt.";
export const engineering_power_title = "Hybrid-Antrieb";
export const engineering_power_desc = "Fortschrittliche Hybrid-Technologie kombiniert rohe Kraft mit Effizienz. Elektromotoren liefern sofortiges Drehmoment, während der Verbrennungsmotor anhaltende Leistung bietet.";
export const engineering_technical_spec = "Technische Spezifikation";
export const engineering_headline1 = "Entwickelt auf";
export const engineering_headline2 = "exakte Toleranzen.";
export const engineering_body = "Jede Zahl unten ist gemessen, nicht geschätzt. Unser Prozess basiert auf Luft- und Raumfahrtmethodik, angewendet auf den automobilen Carbonbau.";
export const engineering_process_overview = "Prozessübersicht";
export const engineering_docs_note = "Vollständige technische Dokumentation auf Projektanfrage verfügbar";
export const engineering_request_docs = "Dokumentation Anfordern";

export const atelier_title = "Interior Atelier";
export const atelier_subtitle = "Maßgeschneiderte Handwerkskunst";
export const atelier_desc = "Unser Interior Atelier verwandelt Kabinen in personalisierte Refugien. Jede Naht, jede Oberfläche, jedes Detail wird nach Ihrer Vision maßgeschneidert. Von handverlesenen Ledern bis zu individuellen Carbon-Geweben fertigen wir Innenräume, die Ihre Individualität widerspiegeln.";
export const atelier_cta = "Gestalten Sie Ihr Interieur";
export const atelier_craftsmanship_label = "Handwerkskunst";
export const atelier_headline = "INTERIEUR / ATELIER";
export const atelier_body = "Wo Materialien auf Meisterschaft treffen. Jede Naht, jede Oberfläche, für Perfektion entwickelt.";
export const atelier_material_label = "MATERIAL";
export const atelier_our_services = "UNSERE LEISTUNGEN";
export const atelier_schedule = "BERATUNG VEREINBAREN";

export const performance_title = "Performance Line";
export const performance_subtitle = "Kompromisslose Kraft";
export const performance_spec_power = "Leistung";
export const performance_spec_torque = "Maximales Drehmoment";
export const performance_spec_weight = "Leergewicht";
export const performance_spec_acceleration = "0-100 km/h";
export const performance_spec_top_speed = "Höchstgeschwindigkeit";
export const performance_cta = "Spezifikationen Ansehen";
export const performance_label = "Performance";
export const performance_headline1 = "ENTWICKELTE";
export const performance_headline2 = "DYNAMIK";

export const models_title = "Modellgalerie";
export const models_subtitle = "Entdecken Sie Unsere Kollektion";
export const models_search_placeholder = "Modelle suchen...";
export const models_filter_all = "Alle Modelle";
export const models_filter_hypercar = "Hypercar";
export const models_filter_gt = "GT";
export const models_filter_roadster = "Roadster";
export const models_filter_limited = "Limitierte Edition";
export const models_view = "Details Ansehen";
export const models_configure = "Konfigurieren";
export const models_config_label = "Konfiguration · Modelle";
export const models_headline = "MODELLE / GALERIE";
export const models_body = "Wählen Sie Ihr Basisfahrzeug und konfigurieren Sie es nach Ihrer Vision. Jedes Projekt wird individuell ausgeführt.";
export const models_available = "Modelle zur Konfiguration verfügbar";
export const models_ask_another = "NACH EINEM ANDEREN MODELL FRAGEN";
export const models_swipe = "WISCHEN ZUM ENTDECKEN";

export const process_title = "Build-Prozess";
export const process_subtitle = "Von der Vision zur Realität";
export const process_step1_title = "Beratung";
export const process_step1_desc = "Beginnen Sie Ihre Reise mit unserem Designteam. Wir erkunden Ihre Vision, Präferenzen und Leistungsanforderungen.";
export const process_step2_title = "Konfiguration";
export const process_step2_desc = "Wählen Sie jedes Detail—von Carbon-Gewebemustern bis zu Interieurmaterialien. Visualisieren Sie Ihren Build in Echtzeit.";
export const process_step3_title = "Entwicklung";
export const process_step3_desc = "Unsere Ingenieure optimieren jede Komponente für Ihre Spezifikationen und gewährleisten Spitzenleistung und Zuverlässigkeit.";
export const process_step4_title = "Fertigung";
export const process_step4_desc = "Meisterhandwerker erwecken Ihre Vision zum Leben und bauen jede Komponente mit Präzision und Sorgfalt von Hand.";
export const process_step5_title = "Auslieferung";
export const process_step5_desc = "Erleben Sie den Moment, in dem Ihr Meisterwerk ankommt. Umfassende Übergabe und lebenslanger Support inklusive.";
export const process_label = "Build-Prozess";
export const process_headline1 = "Von rohem Carbon";
export const process_headline2 = "zur fertigen Kunst.";
export const process_body = "Jeder ORVANTHE-Build folgt einem akribischen sechsstufigen Prozess. Keine Abkürzungen. Kein Outsourcing. Jedes Fahrzeug ist ein einzigartiger Ausdruck von Präzision und Handwerk.";
export const process_start_build = "Starten Sie Ihren Build";
export const process_hours = "Stunden pro Build";
export const process_craftsmen = "Meisterhandwerker";
export const process_inspection = "Punkte-Inspektion";
export const process_warranty = "Strukturgarantie";

export const contact_title = "Starten Sie Ihren Build";
export const contact_subtitle = "Lassen Sie Uns Etwas Außergewöhnliches Schaffen";
export const contact_form_name = "Vollständiger Name";
export const contact_form_email = "E-Mail-Adresse";
export const contact_form_phone = "Telefonnummer";
export const contact_form_interest = "Ich Interessiere Mich Für";
export const contact_form_interest_new = "Neuer Build";
export const contact_form_interest_custom = "Individuelles Projekt";
export const contact_form_interest_carbon = "Carbon Division";
export const contact_form_interest_atelier = "Interior Atelier";
export const contact_form_interest_inquiry = "Allgemeine Anfrage";
export const contact_form_message = "Erzählen Sie Uns von Ihrer Vision";
export const contact_form_submit = "Anfrage Senden";
export const contact_form_submitting = "Wird Gesendet...";
export const contact_form_success = "Vielen Dank! Wir melden uns innerhalb von 24 Stunden.";
export const contact_form_error = "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.";
export const contact_form_required = "Dieses Feld ist erforderlich";
export const contact_form_email_invalid = "Bitte geben Sie eine gültige E-Mail-Adresse ein";
export const contact_configure_label = "Konfigurieren";
export const contact_headline1 = "STARTEN SIE IHREN";
export const contact_headline2 = "BUILD";
export const contact_body = "Wählen Sie Ihr Paket, wählen Sie Ihr Fahrzeug, und wir schaffen etwas Unwiederholbares.";
export const contact_step_package = "Paket";
export const contact_step_vehicle = "Fahrzeug";
export const contact_step_details = "Details";
export const contact_continue = "Weiter";
export const contact_back = "Zurück";
export const contact_edit = "Bearbeiten";
export const contact_change = "Ändern";
export const contact_select_brand = "Marke Auswählen *";
export const contact_select_model = "Modell Auswählen *";
export const contact_enter_vehicle = "Ihr Fahrzeug Eingeben *";
export const contact_timeline_label = "Bevorzugter Zeitrahmen";
export const contact_timeline_placeholder = "Zeitrahmen auswählen";
export const contact_timeline_asap = "So schnell wie möglich";
export const contact_timeline_1_3 = "1–3 Monate";
export const contact_timeline_3_6 = "3–6 Monate";
export const contact_timeline_6_12 = "6–12 Monate";
export const contact_timeline_exploring = "Nur Optionen erkunden";
export const contact_additional_details = "Zusätzliche Details";
export const contact_message_placeholder = "Erzählen Sie uns von Ihrer Vision — Farbpräferenzen, spezifische Modifikationen, Inspiration...";
export const contact_submit_inquiry = "Anfrage Senden";
export const contact_processing = "Wird Verarbeitet...";
export const contact_success = "Vielen Dank! Wir kontaktieren Sie innerhalb von 24 Stunden, um Ihren Build zu besprechen.";
export const contact_error = "Bitte füllen Sie alle Pflichtfelder aus und versuchen Sie es erneut.";
export const contact_location = "Warschau, PL";

export const news_title = "Neueste Nachrichten";
export const news_subtitle = "Updates von Veragua";
export const news_read_more = "Mehr Lesen";

export const social_title = "Folgen Sie Unserer Reise";
export const social_subtitle = "Hinter den Kulissen";
export const social_view_post = "Beitrag Ansehen";

export const footer_tagline = "Ingenieurskunst par Excellence. Kompromisslose Leistung.";
export const footer_company = "Unternehmen";
export const footer_company_about = "Über Uns";
export const footer_company_careers = "Karriere";
export const footer_company_press = "Presse";
export const footer_company_contact = "Kontakt";
export const footer_models = "Modelle";
export const footer_models_hypercar = "Hypercar-Serie";
export const footer_models_gt = "GT-Kollektion";
export const footer_models_roadster = "Roadster-Linie";
export const footer_models_limited = "Limitierte Editionen";
export const footer_services = "Dienstleistungen";
export const footer_services_carbon = "Carbon Division";
export const footer_services_atelier = "Interior Atelier";
export const footer_services_bespoke = "Maßgeschneiderte Projekte";
export const footer_services_support = "Besitzer-Support";
export const footer_legal = "Rechtliches";
export const footer_legal_privacy = "Datenschutzrichtlinie";
export const footer_legal_terms = "Nutzungsbedingungen";
export const footer_legal_cookies = "Cookie-Richtlinie";
export const footer_copyright = "© 2024 Veragua. Alle Rechte vorbehalten.";
export const footer_powered = "Website-Builder";
export const footer_copyright_text = "© ORVANTHE 2025. ALLE RECHTE VORBEHALTEN.";
export const footer_tagline_short = "Aus Carbon Gefertigt. Ohne Kompromisse Gebaut.";

export const about_hero_title = "Über Veragua";
export const about_hero_subtitle = "Die Zukunft der Leistung Gestalten";
export const about_hero_subtitle_short = "Wo Präzisionsingenieurwesen auf künstlerische Vision trifft";
export const about_hero_scroll = "SCROLLEN";
export const about_story_title = "Unsere Geschichte";
export const about_story_text = "Gegründet auf dem Prinzip, dass Kompromisse keinen Platz in automobiler Exzellenz haben, entstand Veragua aus einer Vision, das Mögliche neu zu definieren. Wir bauen keine Autos—wir entwickeln Erlebnisse, die konventionelle Grenzen überschreiten.";
export const about_story_heading = "Die Anfänge";
export const about_story_p1 = "Im Jahr 2018 gegründet, entstand ORVANTHE aus einer einzigartigen Vision: die Grenzen zwischen Automobilingenieurwesen und bildender Kunst zu überschreiten. Was als Leidenschaftsprojekt in einer bescheidenen Werkstatt begann, hat sich zu einem weltweit anerkannten Atelier automobiler Exzellenz entwickelt.";
export const about_story_p2 = "Unser Gründer, angetrieben von einer Obsession für Perfektion und einem tiefen Respekt vor dem automobilen Erbe, stellte ein Team aus Meisterhandwerkern, Ingenieuren und Designern zusammen, die dieselben kompromisslosen Standards teilten. Gemeinsam entwickelten sie einen neuen Ansatz zur Fahrzeugindividualisierung — einen, der jedes Fahrzeug als Leinwand für Innovation behandelt.";
export const about_story_p3 = "Jedes ORVANTHE-Werk entsteht aus Hunderten von Stunden akribischer Planung, 3D-Scanning und Handveredelung. Wir modifizieren Fahrzeuge nicht einfach; wir rekonstruieren sie auf molekularer Ebene und stellen uns neu vor, was möglich ist, wenn Kunstfertigkeit auf Ingenieurspräzision trifft.";
export const about_story_est = "Gegr. 2018";
export const about_story_since = "PRÄZISION SEIT TAG EINS";

export const about_philosophy_title = "Unsere Philosophie";
export const about_philosophy_text = "Jede Entscheidung, jede Komponente, jedes Detail wird von einem unerschütterlichen Engagement für Perfektion geleitet. Wir glauben an die Reinheit des Zwecks, die Eleganz der Ingenieurskunst und das unermüdliche Streben nach Leistung.";
export const about_phil_heading = "Unsere Philosophie";
export const about_phil_body = "Vier Prinzipien, die jede Entscheidung, jedes Design, jedes Detail leiten";
export const about_phil_p1_title = "Kompromisslose Vision";
export const about_phil_p1_desc = "Wir weigern uns, Einschränkungen zu akzeptieren. Jedes Projekt beginnt mit einer Frage: Was wäre, wenn wir es besser machen könnten? Dieses unermüdliche Streben nach Perfektion treibt jede Entscheidung, jede Messung, jedes Finish an.";
export const about_phil_p2_title = "Handwerkskunst der Meister";
export const about_phil_p2_desc = "In einem Zeitalter der Automatisierung setzen wir auf den menschlichen Touch. Unsere Meisterhandwerker verbringen Jahre damit, ihre Fähigkeiten zu perfektionieren und sicherzustellen, dass jede Oberfläche, jede Naht, jedes Detail die höchsten Qualitätsstandards widerspiegelt.";
export const about_phil_p3_title = "Innovation Ohne Kompromisse";
export const about_phil_p3_desc = "Wir begrüßen modernste Technologie — 3D-Scanning, Carbon-Faser-Engineering, fortschrittliche Aerodynamik — aber niemals auf Kosten der Seele. Technologie dient der Kunstfertigkeit, nicht umgekehrt.";
export const about_phil_p4_title = "Kundenpartnerschaft";
export const about_phil_p4_desc = "Jedes ORVANTHE-Werk ist eine Zusammenarbeit. Wir hören zu, beraten, verfeinern. Ihre Vision wird unsere Mission, und gemeinsam schaffen wir etwas, das Erwartungen übertrifft.";

export const about_craftsmanship_title = "Handwerkskunst";
export const about_craftsmanship_text = "Unsere Meisterhandwerker kombinieren traditionelle Techniken mit modernster Technologie. Jedes Fahrzeug wird von Hand gebaut und stellt sicher, dass jede Oberfläche, jede Naht, jede Komponente unseren anspruchsvollen Standards entspricht.";
export const about_craft_heading = "In Zahlen";
export const about_craft_body = "Präzision, Hingabe und Exzellenz gemessen";
export const about_craft_quote = "Wir bauen keine Autos. Wir meißeln Träume aus Carbon und Stahl und erschaffen Ingenieurpoesie, die sich mit 320 km/h bewegt.";
export const about_craft_manifesto = "ORVANTHE MANIFEST";
export const about_craft_stat1_label = "Stunden pro Build";
export const about_craft_stat1_desc = "Akribische Aufmerksamkeit für jedes Detail";
export const about_craft_stat2_label = "Meisterhandwerker";
export const about_craft_stat2_desc = "Jahrzehnte kombinierter Erfahrung";
export const about_craft_stat3_label = "Präzisionstoleranz";
export const about_craft_stat3_desc = "Ingenieurwesen auf mikroskopischer Ebene";
export const about_craft_stat4_label = "Handgefertigt";
export const about_craft_stat4_desc = "Keine Abkürzungen, keine Kompromisse";

export const about_vision_title = "Unsere Vision";
export const about_vision_text = "Wir stellen uns eine Zukunft vor, in der Leistung und Nachhaltigkeit koexistieren, in der Technologie das Fahrerlebnis verbessert, ohne es zu schmälern, und in der jede Fahrt ein Ausdruck automobiler Kunstfertigkeit ist.";
export const about_vision_heading = "In die Zukunft Blicken";
export const about_vision_p1 = "Die Zukunft von ORVANTHE dreht sich nicht um Volumen — es geht um Wirkung. Wir werden unsere Standards niemals kompromittieren, um die Produktion zu skalieren. Stattdessen investieren wir in Materialien der nächsten Generation, fortschrittliche Aerodynamik und nachhaltige Ingenieurpraktiken.";
export const about_vision_p2 = "Unsere Vision geht über individuelle Builds hinaus. Wir schaffen ein Erbe der Innovation, bilden die nächste Generation von Meisterhandwerkern aus und verschieben die Grenzen des Möglichen, wenn Kunst und Ingenieurwesen konvergieren.";
export const about_vision_p3 = "Jedes ORVANTHE-Fahrzeug ist ein Statement: dass Exzellenz nicht überstürzt werden kann, dass Schönheit Geduld erfordert, und dass wahre Luxus nicht im Preis gemessen wird, sondern im Streben nach Perfektion.";
export const about_vision_sustain_title = "Nachhaltige Innovation";
export const about_vision_sustain_desc = "CO₂-neutrale Fertigung bis 2026";
export const about_vision_academy_title = "Handwerker-Akademie";
export const about_vision_academy_desc = "Ausbildung der nächsten Generation von Handwerkern";
export const about_vision_materials_title = "Zukunftsmaterialien";
export const about_vision_materials_desc = "Wegweisende Verbundwerkstoffe in Luft- und Raumfahrtqualität";
export const about_vision_statement = "Das ist kein Styling. Das ist Rekonstruktion.";

export const back_to_top = "Zurück nach oben";

export const common = {
  nav: {
    carbon: 'CARBON',
    builds: 'PROJEKTE',
    atelier: 'ATELIER',
    performance: 'PERFORMANCE',
  },
};

export const de = {
  contact: {
    hero: {
      eyebrow: 'Kontakt aufnehmen',
      title: 'Kontakt',
      subtitle: 'Kontaktieren Sie uns, um Ihre Vision zu besprechen, einen Studiobesuch zu vereinbaren oder sich über unsere Dienstleistungen zu informieren.'
    },
    info: {
      title: 'Studio-Informationen',
      address: {
        label: 'Adresse',
        value: 'Aleje Jerozolimskie 123',
        subvalue: '00-001 Warschau, Polen'
      },
      email: {
        label: 'E-Mail',
      },
      phone: {
        label: 'Telefon',
      },
      hours: {
        label: 'Öffnungszeiten',
        value: 'Montag – Freitag: 9:00 – 18:00',
        subvalue: 'Samstag: Nur nach Vereinbarung'
      },
      social: 'Folgen Sie uns'
    },
    visit: {
      title: 'Studiobesuch vereinbaren',
      description: 'Erleben Sie ORVANTHE hautnah. Besichtigen Sie unsere Einrichtung, lernen Sie unser Team kennen und erkunden Sie unsere Materialbibliothek und fertiggestellte Projekte.',
      benefit1: 'Private Beratung mit unserem Designteam',
      benefit2: 'Praktische Material- und Oberflächenauswahl',
      benefit3: 'Aktuelle Projekte in Arbeit ansehen',
      cta: 'Besuch buchen',
      form: {
        title: 'Studiobesuch buchen',
        subtitle: 'Wählen Sie Ihr bevorzugtes Datum und Ihre Uhrzeit. Wir bestätigen die Verfügbarkeit innerhalb von 24 Stunden.',
        name: 'Vollständiger Name',
        email: 'E-Mail-Adresse',
        phone: 'Telefonnummer',
        date: 'Bevorzugtes Datum',
        time: 'Bevorzugte Uhrzeit',
        visitors: 'Anzahl der Besucher',
        selectTime: 'Uhrzeit wählen',
        notes: 'Zusätzliche Anmerkungen',
        notesPlaceholder: 'Besondere Interessen oder Fragen?',
        submit: 'Buchung bestätigen',
        submitting: 'Wird gesendet...',
        validation: 'Bitte füllen Sie alle erforderlichen Felder aus.',
        success: {
          title: 'Besuch geplant',
          message: 'Ihr Studiobesuch wurde bestätigt. Wir senden Ihnen in Kürze eine Bestätigungs-E-Mail.'
        }
      }
    },
    form: {
      title: 'Senden Sie uns eine Nachricht',
      subtitle: 'Wir antworten in der Regel innerhalb von 24 Stunden.',
      name: 'Vollständiger Name',
      namePlaceholder: 'Max Mustermann',
      email: 'E-Mail-Adresse',
      emailPlaceholder: 'max@beispiel.de',
      phone: 'Telefonnummer',
      phonePlaceholder: '+49 123 456 789',
      subject: 'Betreff',
      subjectPlaceholder: 'Betreff auswählen',
      subjects: {
        general: 'Allgemeine Anfrage',
        carbon: 'Carbon-Abteilung',
        atelier: 'Innenraum-Atelier',
        performance: 'Performance-Linie',
        build: 'Individuelle Projektanfrage',
        partnership: 'Partnerschaftsmöglichkeit'
      },
      message: 'Nachricht',
      messagePlaceholder: 'Erzählen Sie uns von Ihrem Projekt oder Ihrer Anfrage...',
      characters: 'Zeichen',
      submit: 'Nachricht senden',
      sending: 'Wird gesendet...',
      validation: 'Bitte füllen Sie alle erforderlichen Felder aus.',
      maxLength: 'Die Nachricht darf 500 Zeichen nicht überschreiten.',
      success: {
        title: 'Nachricht gesendet',
        message: 'Vielen Dank für Ihre Kontaktaufnahme. Wir haben Ihre Nachricht erhalten.',
        response: 'Unser Team wird innerhalb von 24 Stunden antworten.'
      }
    },
    map: {
      title: 'Finden Sie unser Studio',
      subtitle: 'Im Herzen von Warschau gelegen',
      location: 'Studio-Standort'
    },
    faq: {
      title: 'Häufig gestellte Fragen',
      subtitle: 'Schnelle Antworten auf häufige Anfragen',
      q1: {
        question: 'Wie lange dauert ein individuelles Projekt normalerweise?',
        answer: 'Die meisten Projekte dauern 8-16 Wochen von der ersten Beratung bis zur Lieferung, abhängig von Komplexität und Materialverfügbarkeit. Express-Services sind für ausgewählte Pakete verfügbar.'
      },
      q2: {
        question: 'Versenden Sie international?',
        answer: 'Ja, wir versenden weltweit. Alle Carbon-Komponenten werden sorgfältig verpackt und versichert. Installationsunterstützung kann über unser Partnernetzwerk arrangiert werden.'
      },
      q3: {
        question: 'Kann ich das Studio ohne Termin besuchen?',
        answer: 'Wir empfehlen, einen Besuch im Voraus zu vereinbaren, um sicherzustellen, dass unser Team verfügbar ist und Ihnen eine umfassende Führung und Beratung bieten kann.'
      },
      q4: {
        question: 'Welche Zahlungsmethoden akzeptieren Sie?',
        answer: 'Wir akzeptieren Banküberweisungen, Kreditkarten und Kryptowährungen. Eine Anzahlung von 50% ist erforderlich, um mit der Arbeit zu beginnen, der Restbetrag ist bei Fertigstellung fällig.'
      },
      q5: {
        question: 'Bieten Sie Installationsservices an?',
        answer: 'Ja, professionelle Installation ist in unserem Studio oder über unser zertifiziertes Partnernetzwerk in ganz Europa und darüber hinaus verfügbar.'
      },
      q6: {
        question: 'Welche Garantie bieten Sie?',
        answer: 'Alle ORVANTHE-Produkte haben eine 2-jährige Garantie gegen Herstellungsfehler. Carbon-Komponenten beinhalten eine lebenslange Strukturgarantie.'
      },
      more: 'Haben Sie noch Fragen?',
      email: 'Schreiben Sie uns direkt'
    }
  }
};
